export const API_BASE_URL = (process.env.NODE_ENV !== 'production'? "http://localhost:5163" : "https://wms-api.andreyusdianto.com");

export const LANDING_PAGE_URL = API_BASE_URL +  '/Dashboard';
export const SIGN_IN_URL = API_BASE_URL +  '/Account/SignIn';
export const SIGN_OUT_URL = API_BASE_URL +  '/Account/SignOut';

//Master API
export const MST_USER_READ_URL = API_BASE_URL +  '/MstUser/Read';
export const MST_USER_CREATE_URL = API_BASE_URL +  '/MstUser/Create';
export const MST_USER_UPDATE_URL = API_BASE_URL +  '/MstUser/Update';
export const MST_USER_DELETE_URL = API_BASE_URL +  '/MstUser/Delete';
export const MST_USER_LOCATION_MAPPING_URL = API_BASE_URL +  '/MstUser/UserLocationMapping';

export const MST_ROLE_READ_URL = API_BASE_URL +  '/MstRole/Read';
export const MST_ROLE_CREATE_URL = API_BASE_URL +  '/MstRole/Create';
export const MST_ROLE_UPDATE_URL = API_BASE_URL +  '/MstRole/Update';
export const MST_ROLE_DELETE_URL = API_BASE_URL +  '/MstRole/Delete';
export const GET_ROLE_MAPPING_FUNCTION_URL = API_BASE_URL +  '/MstRole/RoleFunctionMapping';

export const MST_LAYOUT_READ_URL = API_BASE_URL +  '/MstLayout/Read';
export const MST_LAYOUT_CREATE_URL = API_BASE_URL +  '/MstLayout/Create';
export const MST_LAYOUT_UPDATE_URL = API_BASE_URL +  '/MstLayout/Update';
export const MST_LAYOUT_DELETE_URL = API_BASE_URL +  '/MstLayout/Delete';
export const MST_LAYOUT_GET_MAPPING_LAYOUT_URL = API_BASE_URL +  '/MstLayout/GetMappingLayoutData';
export const MST_LAYOUT_UPDATE_MAPPING_LAYOUT_URL = API_BASE_URL +  '/MstLayout/UpdateMappingLayout';

export const MST_RACK_TYPE_READ_URL = API_BASE_URL +  '/MstRackType/Read';
export const MST_RACK_TYPE_CREATE_URL = API_BASE_URL +  '/MstRackType/Create';
export const MST_RACK_TYPE_UPDATE_URL = API_BASE_URL +  '/MstRackType/Update';
export const MST_RACK_TYPE_DELETE_URL = API_BASE_URL +  '/MstRackType/Delete';

export const MST_RACK_CATEGORY_READ_URL = API_BASE_URL +  '/MstRackCategory/Read';
export const MST_RACK_CATEGORY_CREATE_URL = API_BASE_URL +  '/MstRackCategory/Create';
export const MST_RACK_CATEGORY_UPDATE_URL = API_BASE_URL +  '/MstRackCategory/Update';
export const MST_RACK_CATEGORY_DELETE_URL = API_BASE_URL +  '/MstRackCategory/Delete';

export const MST_LOCATION_READ_URL = API_BASE_URL +  '/MstLocation/Read';
export const MST_LOCATION_CREATE_URL = API_BASE_URL +  '/MstLocation/Create';
export const MST_LOCATION_UPDATE_URL = API_BASE_URL +  '/MstLocation/Update';
export const MST_LOCATION_DELETE_URL = API_BASE_URL +  '/MstLocation/Delete';

export const MST_WAREHOUSE_READ_URL = API_BASE_URL +  '/MstWarehouse/Read';
export const MST_WAREHOUSE_CREATE_URL = API_BASE_URL +  '/MstWarehouse/Create';
export const MST_WAREHOUSE_UPDATE_URL = API_BASE_URL +  '/MstWarehouse/Update';
export const MST_WAREHOUSE_DELETE_URL = API_BASE_URL +  '/MstWarehouse/Delete';

export const GET_ROLE_LIST_URL = API_BASE_URL +  '/Report/GetRoleList';

export const GET_BU_LIST_URL = API_BASE_URL +  '/Report/GetBUList';
export const GET_GBP_LIST_URL = API_BASE_URL +  '/Report/GetGBPList';
export const GET_RACK_TYPE_LIST_URL = API_BASE_URL +  '/Report/GetRackTypeList';
export const GET_RACK_CATEGORY_LIST_URL = API_BASE_URL +  '/Report/GetRackCategoryList';
export const GET_GBP_USER_MAPPING_LOCATION_LIST_URL = API_BASE_URL +  '/Report/GetUserMappingLocationGBPList';
export const GET_WAREHOUSE_BEING_USED_LIST_URL = API_BASE_URL +  '/Report/GeWarehouseBeingUsedList';
export const GET_LAYOUT_BY_WAREHOUSE_LIST_URL = API_BASE_URL +  '/Report/GetLayoutByWarehouseList';


export const REPORT_MAPPING_LAYOUT_URL = API_BASE_URL +  '/MappingLayoutReport/GetMappingLayoutData';